import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { AffinityBlacklistEntry } from "../../recommendation.types";
import { requestGetAffinityBlacklist } from "./getAffinityBlacklist.request";

const useAffinityBlacklist = (
  options?: QueryOptions<AffinityBlacklistEntry[], ApiServiceError<ApiError>>
) => {
  const { data: blacklist, ...rest } = useQuery({
    queryKey: ["recommendation", "affinity", "blacklist"],
    queryFn: requestGetAffinityBlacklist,
    onError: toastServerError,
    ...options
  });

  return { blacklist: blacklist ?? [], ...rest };
};

export default useAffinityBlacklist;
